import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { fakeTableList, headList, schema } from "./parts";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import {
  CommonOrCommonRetirementFlug,
  Prefectures,
} from "../../assets/data/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import { httpAPI_APP016, httpAPI_INQ007 } from "./api/request";
import { IAPI_APP016_Request } from "../../type/apiType";
import { TkGetCode } from "../../utils/TkGetCode";
import { Box } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { GlobalContext } from "../../context/globalContext";
import TkMemo from "../../components/molecules/TkMemo";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import { funStatusBodyList } from "./../SCRW070012/hooks/useHooks";
import { BusinessContext } from "../../context/businessContext";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

/**
 * SCRW070012 原簿閲覧請求
 * @return SCRW070012 原簿閲覧請求
 */
const SCRW070012 = () => {
  const navigate = useNavigate();
  const [stateTableList, setStateTableList] = useState<any>([]);
  const location = useLocation();
  let locationState = location.state;
  const [httpReqIApplicationStatusUpdateRequest] =
    useState<IAPI_APP016_Request>({
      applyId: locationState?.applyId!,
      groupApplyId: 0,
      applyEvent: "1",
      contractorNo: "",
      symbolNo: "",
      decisionDate: "",
      conclusionDate: "",
      transferDueDate: "",
      applyDate: "",
      inquiryCode: "0",
      screenId: "",
      reason: "",
      missingFileList: [
        {
          missingSerialNo: 0,
          missingFormKbn: "",
          missingFormClass: "",
          missingFormName: "",
        },
      ],
    });
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [status, setStatus] = useState<any>();
  const [statusBodyList, setStatusBodyList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const handleInit = async () => {
    try {
      const res = await httpAPI_INQ007({
        contractorNo: businessState.common?.contractorNo!,
        applyId: locationState?.applyId!,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
        let resArr = stateFakeTableList.current;
        setStatus(res.latestApplyStatus);

        // 初期表示
        let myNumberDoc = resArr.find(
          (item) => item.keyword === "myNumberDoc"
        )!;
        let identityDoc = resArr.find(
          (item) => item.keyword === "identityDoc"
        )!;
        let identityDocHead = resArr.find(
          (item) => item.keyword === "identityDocHead"
        )!;
        let identityDocTail = resArr.find(
          (item) => item.keyword === "identityDocTail"
        )!;
        let corpName2 = resArr.find((item) => item.keyword === "corpName2")!;
        let location = resArr.find((item) => item.keyword === "location")!;
        let facilityName2 = resArr.find(
          (item) => item.keyword === "facilityName2"
        )!;
        let staffNameKanji = resArr.find(
          (item) => item.keyword === "staffNameKanji"
        )!;
        let birthday = resArr.find((item) => item.keyword === "birthday")!;
        let premiumEnroll = resArr.find(
          (item) => item.keyword === "premiumEnroll"
        )!;

        if (res.latestApplyStatus === "01") {
          corpName2.showLine = false;
          location.showLine = false;
          facilityName2.showLine = false;
          staffNameKanji.showLine = false;
          birthday.showLine = false;
          premiumEnroll.showLine = false;
        } else {
          //承認以降のみ表示する項目
          corpName2.showLine = true;
          location.showLine = true;
          facilityName2.showLine = true;
          staffNameKanji.showLine = true;
          birthday.showLine = true;
          premiumEnroll.showLine = true;
        }

        let keywordMapping: any = {
          corpName2: "corpName",
          location: "addressCity",
          facilityName2: "facilityName",
          premiumEnroll: "premiumEnrollYear",
        };

        let processItems = (items: any[]) => {
          for (let item of items) {
            for (let resItem of resArr) {
              let keyword = keywordMapping[resItem.keyword!] || resItem.keyword;
              if (keyword in item) {
                switch (keyword) {
                  case "addressCity":
                    resItem.text = `〒${item.zipcode}${TkGetCode(
                      Prefectures,
                      item.prefectureCd
                    )}${item.addressCity}${item.addressOthers}`;
                    break;
                  case "premiumEnrollYear":
                    resItem.text = `${item.premiumEnrollYear ?? 0}年${
                      item.premiumEnrollMonth ?? 0
                    }ヶ月`;
                    break;
                  default:
                    resItem.text = item[keyword];
                    resItem.setDefaultValue = item[keyword];
                }
              }
            }
          }
        };

        if (res.registerList) processItems(res.registerList);
        if (res.approvalList) processItems(res.approvalList);
        if (res.formList) processItems(res.formList);
        if (res.statusList) processItems(res.statusList);

        if (res.formList) {
          res.formList.forEach((file: any) => {
            switch (file.formClass) {
              case "27":
                myNumberDoc.showLine = true;
                myNumberDoc.base64filedata = file.fileBase64;
                myNumberDoc.dataname = file.fileName;
                break;
              case "23":
                identityDoc.showLine = true;
                identityDoc.base64filedata = file.fileBase64;
                identityDoc.dataname = file.fileName;
                break;
              case "24":
                identityDocHead.showLine = true;
                identityDocHead.base64filedata = file.fileBase64;
                identityDocHead.dataname = file.fileName;
                break;
              case "25":
                identityDocTail.showLine = true;
                identityDocTail.base64filedata = file.fileBase64;
                identityDocTail.dataname = file.fileName;
                break;
            }
          });
        }

        const statusList = funStatusBodyList(res.statusList);
        setStatusBodyList(statusList);

        const bodyList = [
          [{ children: res.approvalDate }, { children: res.symbolNo }],
        ];
        setBodyList(bodyList);

        setStateTableList([...resArr]);
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (data: IAPI_APP016_Request, num: any, formData?: any) => {
    data.applyEvent = num;
    data.reason = memoData;

    if (memoCheck) {
      data.inquiryCode = "3";
    }

    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }
    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : btnName === "通知"
        ? "9"
        : btnName === "郵送"
        ? "11"
        : "";

    if (num === "") {
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }

    if (num === "9") {
      const noticeObj: any = {
        applyId: locationState?.applyId!,
        screenId: "SCRW070012",
        memo: memoData,
      };
      if (memoCheck) {
        noticeObj.refInquiryScreen = "3";
      }

      navigate("/SCRW130001", {
        state: {
          ...location.state,
          ...noticeObj,
        },
      });
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      num
    );

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      "3",
      formData
    );
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  return (
    <Box data-testid="SCRW070012PageForTest" className="SCRW070012">
      <Box>
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-44"
          applicationStatus={status}
        />
      </Box>
      <Box className="body">
        <TkFakeTable
          list={stateTableList}
          ruleSchema={schema}
          showButton={false}
        />

        <TkMemo
          bodyList={statusBodyList}
          showTable={true}
          onChange={onChange}
        ></TkMemo>

        {isStatusAfterApproval(status) && (
          <TkTableWithNoLine headList={headList} bodyList={bodyList} />
        )}

        <Box className="btn">
          <TkBackButton className="tkBottonMr" />
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status}
            onClick={btnEvent}
          />
        </Box>

        <TkApprovalDateSymbolNumberRegistrationDialog
          data-testid="SCRW070012PageForDialog"
          open={isOpen}
          onSuccess={handleSave}
          onClose={setOpen}
        />
      </Box>
    </Box>
  );
};

export default SCRW070012;
